<template>
  <div class="dashboard">
    <div class="block__content--table">
      <div class="row">
        <div class="col-12">
          <div class="page__head-title page__head-title--orange">
            <div class="page__head-title__text page__head-title__text--orange">Tableau de bord</div>
          </div>
          <div class="form_ttl_first">Vos statistiques</div>
        </div>
      </div>

      <template v-if="isStatsLoading">
        <Preloader />
      </template>
      <template v-else>
        <table>
          <thead>
            <tr>
              <th>Garantie</th>
              <th>Quantité</th>
              <th>Prime</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in stats" :key="index">
              <td>{{ item.title }}</td>
              <td>{{ item.qty }}</td>
              <td>{{ item.price | formatEURWithoutSymbol | formatSeparateComma }} €</td>
            </tr>
            <tr>
              <td><b>Total</b></td>
              <td><b>{{ totalStats.qty }}</b></td>
              <td><b>{{ totalStats.price | formatEURWithoutSymbol | formatSeparateComma }} €</b></td>
            </tr>
          </tbody>
        </table>
      </template>
    </div>

    <div class="block__content--chart" v-show="!isStatsLoading">
      <div class="row">
        <div class="col-12 col-sm-6">
          <div class="dougnhut-chart-wrapper">
            <div class="dougnhut-chart-wrapper__center-text">
              <p class="dougnhut-chart-wrapper__center-text--count">{{ totalStats.price | formatEURWithoutSymbol | formatSeparateComma }} €</p>
              <p class="dougnhut-chart-wrapper__center-text--title">Total</p>
            </div>
            <canvas id="account-quotes-doughnut-chart" width="300px" height="300px"></canvas>
          </div>
        </div>
        <div class="col-12 col-sm-6">
          <div class="assets-list">
            <div class="assets-list__item" v-for="(item, index) in stats" :key="index">
              <div class="assets-list__item--percentage">{{ item.qty }}</div>
              <div class="assets-list__item--title">{{ item.title }}</div>
              <div class="assets-list__item--border" :style="{ backgroundColor: getDurationColor(item.duration) }"></div>
              <div class="assets-list__item--data">{{ item.price | formatEURWithoutSymbol | formatSeparateComma }} €</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="block__content--table">
      <div class="row">
        <div class="col-12">
          <div class="page__head-title page__head-title--orange">
            <div class="page__head-title__text page__head-title__text--orange">Garanties souscrites</div>
            <div class="page__head-title__text__small">
              <span class="page__head-title__text__small--orange">
                (7 derniers jours)
              </span>
            </div>
          </div>
        </div>
      </div>

      <template v-if="isRecentLoading">
        <Preloader />
      </template>
      <template v-else>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>N° Garantie</th>
              <th>Client / Praticien</th>
              <th>Société</th>
              <th>Durée</th>
              <th>Prime</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="garanty in recentGuarantees" :key="garanty.id">
              <td>{{ formatDate(garanty.subscription_date || garanty.created_at) }}</td>
              <td><b>{{ garanty.quote_number || ' - ' }}</b></td>
              <td>{{ garanty.dental_client ? garanty.dental_client.name : ' - ' }}</td>
              <td>{{ (garanty.dental_client && garanty.dental_client.company) ? garanty.dental_client.company : ' - ' }}</td>
              <td>{{ garanty.duration ? garanty.duration + ' mois' : ' - ' }}</td>
              <td>{{ garanty.price | formatEURWithoutSymbol | formatSeparateComma }} €</td>
            </tr>
            <tr v-if="recentGuarantees.length === 0">
              <td colspan="6" class="text-center py-4 text-muted">
                Aucune garantie souscrite au cours des 7 derniers jours.
              </td>
            </tr>
          </tbody>
        </table>
      </template>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js';
import Preloader from '@/components/Preloader';
import formats from '@/mixins/formats';

export default {
  name: 'DentalDashboard',
  components: { Preloader },
  mixins: [formats],
  data() {
    return {
      stats: [
        { duration: 12, title: 'Garantie 12 mois', qty: 0, price: 0 },
        { duration: 24, title: 'Garantie 24 mois', qty: 0, price: 0 },
        { duration: 36, title: 'Garantie 36 mois', qty: 0, price: 0 },
      ],
      totalStats: {
        qty: 0,
        price: 0,
      },
      recentGuarantees: [],
      isStatsLoading: true,
      isRecentLoading: true,
      doughnutChart: null,
    };
  },
  methods: {
    getDurationColor(duration) {
      switch (+duration) {
        case 12:
          return '#008cc9';
        case 24:
          return '#ffc500';
        case 36:
          return '#ff0000';
        default:
          return '#6c757d';
      }
    },
    formatDate(dateVal) {
      if (!dateVal) return ' - ';
      return this.moment(dateVal).format('DD/MM/YYYY');
    },
    fetchStats() {
      this.isStatsLoading = true;
      this.apiGet('dental/stats', {}, false)
        .then((response) => {
          if (response && response.data && response.data.data) {
            const data = response.data.data;
            if (Array.isArray(data.stats)) {
              this.stats = data.stats;
            }
            if (data.total) {
              this.totalStats = data.total;
            }
          }
        })
        .catch((error) => {
          console.error('Error fetching dental dashboard stats:', error);
        })
        .finally(() => {
          this.isStatsLoading = false;
          this.$nextTick(() => {
            this.renderChart();
          });
        });
    },
    fetchRecentGuarantees() {
      this.isRecentLoading = true;
      const startDate = this.moment().subtract(7, 'days').format('YYYY-MM-DD');
      this.apiGet('dental/guarantees', {
        start_date: startDate,
        sort: 'subscription_date|desc',
      }, false)
        .then((response) => {
          if (response && response.data) {
            this.recentGuarantees = Array.isArray(response.data.data) ? response.data.data : [];
          }
        })
        .catch((error) => {
          console.error('Error fetching recent dental guarantees:', error);
        })
        .finally(() => {
          this.isRecentLoading = false;
        });
    },
    renderChart() {
      let doughnutChartContainer = $('#account-quotes-doughnut-chart');
      if (!doughnutChartContainer.length) return;

      if (this.doughnutChart) {
        this.doughnutChart.destroy();
      }

      let data = [],
        backgroundColor = [],
        labels = [];

      for (let i in this.stats) {
        data.push(this.stats[i].price);
        backgroundColor.push(this.getDurationColor(this.stats[i].duration));
        labels.push(this.stats[i].title);
      }

      const hasData = data.some(v => v > 0);
      const finalData = hasData ? data : [1];
      const finalColors = hasData ? backgroundColor : ['#e9ecef'];

      this.doughnutChart = new Chart(doughnutChartContainer, {
        type: 'doughnut',
        data: {
          datasets: [{
            data: finalData,
            backgroundColor: finalColors,
            borderColor: 'transparent',
          }],
          labels: hasData ? labels : ['Aucune donnée'],
        },
        options: {
          animation: false,
          responsive: false,
          maintainAspectRatio: false,
          legend: {
            display: false,
          },
          tooltips: {
            enabled: hasData,
            callbacks: {
              label: (tooltipItem, data) => {
                let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index],
                  currency = data.labels[tooltipItem.index];
                return currency + ': ' + this.replaceDotCommaAmount(this.roundEURWithoutSymbol(value)) + ' €';
              },
            },
            backgroundColor: 'rgba(0,0,0,1)',
          },
        },
      });
    },
  },
  mounted() {
    this.fetchStats();
    this.fetchRecentGuarantees();
  },
  beforeDestroy() {
    if (this.doughnutChart) {
      this.doughnutChart.destroy();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Dental/DentalDashboard.vue